export default __webpack_public_path__ + "static/media/42.54d30c8a.jpg";